// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__07h5Z"};